/**
 * Client-side docx → HTML conversion for previewing a freshly generated
 * agreement before insertion. There's no server-rendered page-image
 * available for a draft-generation result (unlike persisted documents,
 * which have a thumbnail pipeline) — mammoth gives a best-effort semantic
 * render (headings, bold, paragraphs), not a pixel-perfect page.
 */

import mammoth from 'mammoth';

/* global atob */

function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

export async function convertDocxToPreviewHtml(contentBase64: string): Promise<string> {
  const arrayBuffer = base64ToArrayBuffer(contentBase64);
  const { value } = await mammoth.convertToHtml({ arrayBuffer });
  return value;
}
